(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["component-select-size"] && !Shopify.designMode) return;
  try {
    if (document.querySelectorAll('.product__variants--option-size').length === 0) return;
  const add_to_cart_button = document.querySelector('.product__add-cart--wrap .btn-add-to-cart');
  const size_options = document.querySelectorAll('.product__variants--option-size');

  // Functie om te checken of er een actieve size optie is
  function checkActiveSizeOption() {
    let hasActiveSize = false;
    
    // Check of 1 van de size_options de class "active" heeft
    size_options.forEach(option => {
      if (option.classList.contains('active')) {
        hasActiveSize = true;
      }
    });

    // Sla de originele button tekst op als die er nog niet is
    if (!add_to_cart_button.dataset.originalText) {
      add_to_cart_button.dataset.originalText = add_to_cart_button.textContent.trim();
    }

    // Als geen actieve size, disable de button en verander de tekst
    if (!hasActiveSize) {
      add_to_cart_button.setAttribute('disabled', 'disabled');
      add_to_cart_button.textContent = 'Selecteer je maat';
    } else {
      add_to_cart_button.removeAttribute('disabled');
      add_to_cart_button.textContent = add_to_cart_button.dataset.originalText;
    }
  }

  // Run de functie bij page load
  checkActiveSizeOption();

  // Run de functie wanneer er op een size optie wordt geklikt
  size_options.forEach(option => {
    option.addEventListener('click', function() {
      // Kleine delay om te wachten tot de active class is toegevoegd/verwijderd
      setTimeout(checkActiveSizeOption, 10);
    });
  });
  } catch(e) { console.error(e); }
})();

})();
